export const Alert = (props: {
  title: string;
  desc: string | string[];
  dismiss: () => void;
}) => (
  <div id="mask" className="alert-mask">
    <div className="alert-dom" onClick={() => null}>
      <span className="alert-title">{props.title}</span>
      {typeof props.desc === "string" ? (
        <span className="alert-desc">{props.desc}</span>
      ) : (
        props.desc.map((descItem, ind) => (
          <span className="alert-desc" key={`desc_${ind}`}>
            {descItem}
          </span>
        ))
      )}
      <div
        className="alert-button"
        onClick={() => {
          props.dismiss();
        }}
      >
        <span>확인</span>
      </div>
    </div>
  </div>
);
